<script setup>
import { ref, computed, onMounted, watch } from "vue";
import { useClassStore } from "@/Store/className";
import { classNames, enrollStudent, enrollStudentLists, enrollStudentActiveLists, checkStudentEnrolment } from "@/services/apiServices";
import { useTheme } from "@/composables/useThemes";
import { apiConfig } from "@/config/apiConfig";
// import { studentLists,  } from "@/services/apiServices";
import banner1 from "@/assets/images/administrator.jpg";
import Swal from "sweetalert2";
import draggable from 'vuedraggable';
const { isDarkTheme } = useTheme();
const classStore = useClassStore();
const initialLoading = ref(false);
const error = ref("");
const classInfoList = computed(() => classStore.classInfoList);
const loading = computed(() => classStore.loading);
const selectedYear = ref(null)
const selectedClass = ref(null)
const selectedClassPromote = ref(null)
const fetchedStudents = ref([]);
const isAddDialogOpen = ref(false);
const previousStudents = ref([]);
const currentStudents = ref([]);
// const table = ref(null);

watch(selectedClass, async (newClassId) => {
  if (!newClassId) {
    fetchedStudents.value = [];
    return;
  }
  if(!selectedYear.value){
    alert("Select year first")
    selectedClass.value = null;
    return;
  }
  try {
    const response = await enrollStudentLists(selectedYear.value, newClassId);
    fetchedStudents.value = response?.filter(Boolean) || [];
    previousStudents.value = [...fetchedStudents.value];
  } catch (err) {
    console.error('Failed to fetch students:', err);
    fetchedStudents.value = [];
  }
});

watch(selectedClassPromote, async(selectedId) =>{
   if (!selectedId) {
    fetchedStudents.value = [];
    return;
  }
  try {
    const response = await enrollStudentActiveLists(selectedId);
    fetchedStudents.value = response?.filter(Boolean) || [];
    currentStudents.value = [...fetchedStudents.value];
  } catch (err) {
    console.error('Failed to fetch students:', err);
    fetchedStudents.value = [];
  }
})

const getImage = (item) => {
  return item ? `${apiConfig.imageUrl}${item}` : banner1;
}
const classItems = computed(() =>
  classInfoList.value.map(item => ({
    title: item.name,
    value: item.id
  }))
);
const years = [
  { title: '२०८२', value: '2082' },
  { title: '२०८३', value: '2083' }
]
const filteredYears = years.slice(0, -1);
const fetchClassInfoList = async () => {
  try {
    initialLoading.value = true;
    const data = await classNames();
    classStore.setClassInfoList(data);
  } catch (err) {
    console.error("Failed to fetch class info list:", err);
    error.value = err.response?.data?.message || "Something went wrong";
  } finally {
    initialLoading.value = false;
  }
};

const onYearChange = async (year) => {
  selectedYear.value = year
  localStorage.setItem("selectedYear", year)
  selectedClass.value = null;  
}
// watch(previousStudents, (newVal) => {
//   console.log("Previous Students Updated:", newVal);
// }, { deep: true });

// watch(currentStudents, (newVal) => {
//   console.log("Current Students Updated:", newVal);
// }, { deep: true });
onMounted(async () =>{fetchClassInfoList();});

const promoteClass = async () => {
  isAddDialogOpen.value = true;
  if (!selectedClassPromote.value) {
    Swal.fire('Please Select Promote Class');
    return;
  }
  if (!currentStudents.value || currentStudents.value.length === 0) {
    Swal.fire('No student selected');
    return;
  }
  const formData = new FormData();
  formData.append("class_id", selectedClassPromote.value);
  formData.append("student_list", JSON.stringify(currentStudents.value));
  const check_student = await checkStudentEnrolment(formData)
  const studentsArray = Array.isArray(check_student) ? check_student : [];
  const studentText = studentsArray.map(student => `${student.name} (${student.class})`).join('<br>');
  const result = await Swal.fire({
  title: `Are you sure you want to promote these students?`,
  html: studentText,  
  icon: "question",
  showCancelButton: true,
  confirmButtonText: "Yes",
  cancelButtonText: "No",
  allowOutsideClick: false
});

if (result.isConfirmed) {
  try {
          formData.append("user_request", "yes");
          const response = await enrollStudent(formData);
          if (response) {
            isAddDialogOpen.value = false;
            Swal.fire({
              icon: "success",
              title: "Student promoted successfully",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              background: isDarkTheme.value ? '#333' : '#fff',
              color: isDarkTheme.value ? '#fff' : '#000',
              iconColor: isDarkTheme ? "#0f0" : "#28a745",
              didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
              },
            });
          selectedClass.value = null;
          selectedYear.value = null;
          selectedClassPromote.value = null;
          previousStudents.value = null;
          currentStudents.value = [];
          }else{
          Swal.fire({
            icon: "warning",
            title: "Oops...",
            text: "All students are already promoted.",
          });
          }

        } catch (error) {
          console.error("Error promote student:", error);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Failed to promote student. Please try again.",
          });
        }
} else {
  try {
          formData.append("user_request", "no");
          const response = await enrollStudent(formData);
          // console.log(response)
          if (response) {
            isAddDialogOpen.value = false;
            Swal.fire({
              icon: "success",
              title: "Student promoted successfully",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              background: isDarkTheme.value ? '#333' : '#fff',
              color: isDarkTheme.value ? '#fff' : '#000',
              iconColor: isDarkTheme ? "#0f0" : "#28a745",
              didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
              },
            });
          selectedClass.value = null;
          selectedYear.value = null;
          selectedClassPromote.value = null;
          previousStudents.value = null;
          currentStudents.value = [];
          }else{
          Swal.fire({
            icon: "warning",
            title: "Oops...",
            text: "All students are already promoted.",
          });
          }
        } catch (error) {
          console.error("Error promote student:", error);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Failed to promote student. Please try again.",
          });
        }
}
  
};
</script>
<template>
  <v-container class="class-dashboard">
    <div class="top_div" style="display: flex;justify-content: space-between;">
      <div style="width:45%;display: flex;flex-direction: column;">
        <div >Search Student from previous year</div>
        <div style="display: flex;gap: 15px;">
          <v-sheet style="width: 50%">
          <v-select
            v-model="selectedYear"
            :items="filteredYears"
            item-title="title"
            item-value="value"
            label="Select Year"
            @update:modelValue="onYearChange"
          />
        </v-sheet>    
        <v-sheet style="width: 50%">
          <v-select
            v-model="selectedClass"
            :items="classItems"
            item-title="title"
            item-value="value"
            label="Select Class"
            outlined
            dense
          />
        </v-sheet>
        </div>
        
    </div>
    <div style="width:45%;display: flex;flex-direction: column;">
       <div >Select class to promote student</div>
        <div style="display: flex;gap: 15px;">
      <v-sheet style="width: 50%">
        <v-select
          v-model="selectedClassPromote"
          :items="classItems"
          item-title="title"
          item-value="value"
          label="Select Class"
          outlined
          dense
        />
      </v-sheet>
      <v-btn color="primary" style="margin-top: 15px;" @click="promoteClass">
        Promote
      </v-btn>
  </div>
    </div>
    </div>
    
    <v-row justify="center" v-if="loading || initialLoading">
      <v-progress-circular indeterminate color="primary" size="40" />
    </v-row>

    <div v-if="error" class="text-error text-center mt-4">
      {{ error }}
    </div>

    <div
      v-else-if="!classInfoList?.length && !loading && !initialLoading"
      class="empty-state text-center"
    >
      <v-icon size="60" color="grey-lighten-1">mdi-account-group</v-icon>
      <h3 class="text-h6 mt-4">No classes found</h3>
      <p class="text-caption">Upload student data to get started</p>
      <v-btn color="primary" to="/uploadFile/student" class="mt-4" size="small">
        <v-icon start>mdi-upload</v-icon>
        Upload Student List
      </v-btn>
    </div>

    <v-divider class="my-4"></v-divider>
  <div class="flex gap-8" style="width: 100%; display: flex;justify-content: space-between;">
    <div class="w-1/2" style="width: 45%;">
      <h3>Previous Students</h3>
      <table class="table-auto w-full border-collapse border border-gray-300" style="width: 100%;">
        <thead>
          <tr class="bg-gray-100">
            <th class="border p-2" style="width: 25%;">ROLL</th>
            <th class="border p-2" style="width: 75%;">NAME</th>
          </tr>
        </thead>
        <draggable
          v-model="previousStudents"
          :group="{ name: 'students', pull: true, put: true }"
          item-key="id"
          tag="tbody"
        >
          <template #item="{ element: student, index }">
            <tr>
               <!-- <td class="border p-2">{{ previousStudents.indexOf(student) + 1 }}</td> -->
              <td class="border p-2">{{ student.roll_no }}</td>
            <td class="border p-2">
              <img :src="getImage(student.image)" class="w-12 h-12 inline-block mr-2" />
              {{ student.name }}
            </td>
            </tr>
          </template>
        </draggable>
      </table>
    </div>

    <div class="w-1/2" style="width: 45%;">
      <h3>Promote Students</h3>
      <table class="table-auto w-full border-collapse border border-gray-300" style="width: 100%;min-height: 100px;background-color: #ededed80;">
        <thead>
          <tr class="bg-gray-100">
            <th class="border p-2" style="width: 25%;">ROLL</th>
            <th class="border p-2" style="width: 75%;">NAME</th>
          </tr>
        </thead>
        <draggable
          v-model="currentStudents"
          :group="{ name: 'students', pull: true, put: true }"
          item-key="id"
          tag="tbody"
        >
          <template #item="{ element: student, index }">
            <tr>
               <!-- <td class="border p-2">{{ currentStudents.indexOf(student) + 1 }}</td> -->
              <td class="border p-2">{{ student.roll_no }}</td>
            <td class="border p-2">
              <img :src="getImage(student.image)" class="w-12 h-12 inline-block mr-2" />
              {{ student.name }}
            </td>
            </tr>
          </template>
        </draggable>
      </table>
    </div>
  </div>
  </v-container>
</template>

<style scoped>
td img{
    width: 35px !important;
    height: 35px !important;
    object-fit: cover;
    border-radius: 8px;
    border: 2px solid #c2cdff;
    padding: 0;
}

tbody tr:hover {
  background-color: #e4e4e4; 
}

</style>
